const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 6);

exports.countryDefinition = {
  country: 'China',
  code: 'CN',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    stateCode: { label: 'Province', width: 0.5 },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'stateCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', 'stateCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(6)),
      error: 'Must be 6 characters, 266033'
    }
  ]
};
